function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.0552236 7.22743C-0.0760399 7.63381 0.0302209 8.06833 0.336502 8.36531L4.36192 12.2916L3.41182 17.8341C3.33994 18.253 3.5087 18.6688 3.85562 18.922C4.04939 19.0626 4.27753 19.1345 4.50568 19.1345C4.6807 19.1345 4.85884 19.0908 5.02449 19.0064L10 16.3899L14.9755 19.0064C15.3537 19.2033 15.8006 19.1721 16.1444 18.922C16.4882 18.6719 16.6569 18.2561 16.5882 17.8341L15.6381 12.2916L19.6635 8.36531C19.9698 8.06833 20.076 7.63069 19.9448 7.22743C19.8135 6.82416 19.4697 6.53344 19.0478 6.47092L13.4816 5.66127L10.9939 0.618958C10.8063 0.23758 10.425 0 9.99687 0C9.56871 0 9.19054 0.23758 8.9999 0.618958L6.51214 5.66127L0.945941 6.47092C0.530273 6.53344 0.186487 6.82104 0.0552236 7.22743Z",
  fill: "#F67DA1"
});

function SvgProductFilledStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductFilledStar);
export default __webpack_public_path__ + "static/media/product_filled_star.2e8b77ed.svg";
export { ForwardRef as ReactComponent };